export const EVENT_STARTED = "Started";
export const EVENT_STARTED_DESC = "MIKE MS config created";
export const EVENT_COMPLETED = "Completed";
export const EVENT_COMPLETED_DESC = "MIKE MS results created";
export const EVENT_PUBLISHED = "Published";
export const EVENT_PUBLISHED_DESC = "MIKE MS results export to MOOD";
export const EVENT_DOWNLOAD = "Download";
export const EVENT_DOWNLOAD_DESC = "MIKE MS results export by download";